import React from 'react'
import ContentContainer from '../../common/Layout/ContentContainer'
import DesktopMenu from './DesktopMenu'
import Logo from './Logo'
import BurgerIcon from '../Icons/BurgerIcon'
import MobileNavigation from './MobileNavigation'
import PropTypes from 'prop-types'

const NavBar = ({ links, navActive, setNavActive }) => (
  <div className='h-full bg-white'>
    <ContentContainer className='relative flex justify-between items-center w-full h-full bg-white z-30'>
      <Logo />
      <DesktopMenu links={links} />
      <BurgerIcon
        className='w-8 h-5 cursor-pointer lg:w-9 lg:h-6 xl:hidden'
        onClick={() => setNavActive(!navActive)}
        active={navActive}
      />
    </ContentContainer>
    <MobileNavigation
      links={links}
      open={navActive}
      onClose={setNavActive}
    />
  </div>
)

export default NavBar

NavBar.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string
    })
  ),
  navActive: PropTypes.bool,
  setNavActive: PropTypes.func
}

NavBar.defaultProps = {
  links: [],
  navActive: false
}
